/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FileNodeDtoPage } from '../../models/file-node-dto-page';

export interface ListFileNodes$Params {
  projectIds?: Array<string>;
  fileNodeIds?: Array<string>;
  parentId?: string;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'projectId' | '-projectId' | 'parent' | '-parent' | 'name' | '-name' | 'attachmentId' | '-attachmentId' | 'isFolder' | '-isFolder' | 'createdAt' | '-createdAt' | 'updatedAt' | '-updatedAt'>;
}

export function listFileNodes(http: HttpClient, rootUrl: string, params?: ListFileNodes$Params, context?: HttpContext): Observable<StrictHttpResponse<FileNodeDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listFileNodes.PATH, 'get');
  if (params) {
    rb.query('projectIds', params.projectIds, {});
    rb.query('fileNodeIds', params.fileNodeIds, {});
    rb.query('parentId', params.parentId, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FileNodeDtoPage>;
    })
  );
}

listFileNodes.PATH = '/v0/fileSystem';
